// extracted by mini-css-extract-plugin
export default {"description":"Vqu0k"};